import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${environment.apiUrl}/profil`;
  private api = `${environment.apiUrl}/password`;
  constructor(private http: HttpClient) {}

  updateUserByUsername(username: string, userData: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + localStorage.getItem('token'));
      // Don't set Content-Type for FormData, let the browser handle it
  
    // Send the FormData directly, no need for 'Content-Type' header
    return this.http.put(`${this.apiUrl}/${username}`, userData, { headers });
  }
  


  updateUserPassword( username: string ,newPassword: string): Observable<any> {
    const body = {
      type: 'password',
      value: newPassword,
      temporary: false // Le mot de passe n'est pas temporaire
    };
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
      .set('Content-Type', 'application/json');  // Ajout du header Content-Type

      return this.http.put<void>(`${this.api}/${username}`, body, { headers });
  }


  
  public username: string = '';

  // 🔐 Fonction pour décoder le token
  public decodeToken(token: string): string {
  
    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        // Adapté selon le contenu de ton token
        this.username = decoded.preferred_username || decoded.sub || decoded.email || '';
      } catch (error) {
        console.error('Erreur lors du décodage du token :', error);
      }
    }
  
    return this.username;
  }
  
  // 📡 Appel à l'API pour récupérer l'utilisateur
  public getUserByUsername(token: string): Observable<any> {
    const username = this.decodeToken(token);
  
    if (!username) {
      return of(null); // Retourne un observable vide si pas de username
    }
  
      

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`
  });
    const url = `${environment.apiUrl}/user/${username}`;

    return this.http.get(url, { headers }).pipe(
      tap((userData) => {
        console.log('Utilisateur récupéré :', userData);
        localStorage.setItem('user', JSON.stringify(userData));
      }),
      catchError((error) => {
        console.error("Erreur lors de la récupération de l'utilisateur :", error);
        return throwError(() => error);
      })
    );
  }

  public getUserByUsernameUpdate(username: string): Observable<any> {
   
  
    if (!username) {
      return of(null); // Retourne un observable vide si pas de username
    }
   const token = localStorage.getItem('token'); // ou 'access_token' selon ton stockage

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`
  });
    const url = `${environment.apiUrl}/user/${username}`;
  
    return this.http.get(url, { headers }).pipe(
      tap((userData) => {
        console.log('Utilisateur récupéré :', userData);
        
        localStorage.setItem('user', JSON.stringify(userData));
      }),
      catchError((error) => {
        console.error("Erreur lors de la récupération de l'utilisateur :", error);
        return throwError(() => error);
      })
    );
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + token)
      .set('Content-Type', 'application/x-www-form-urlencoded');

    const body = new URLSearchParams();
    body.set('oldPassword', oldPassword);
    body.set('newPassword', newPassword);

    return this.http.post(`${environment.apiUrl}/auth/password/change`, body.toString(), { headers });
  }
  
}
